import List from '../material_design/list'

export default {
  setup() {
    List.setup.call(this)
  },
  destroy() {
    List.destroy.call(this)
  },
  mounted() {
    this.setup()
  },
  destroyed() {
    this.destroy()
  }
}
